import { render, staticRenderFns } from "./PropertyForm.vue?vue&type=template&id=7878f595"
import script from "./PropertyForm.vue?vue&type=script&lang=js"
export * from "./PropertyForm.vue?vue&type=script&lang=js"
import style0 from "./PropertyForm.vue?vue&type=style&index=0&id=7878f595&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports